import { render, staticRenderFns } from "./ResourceTypesListTable.vue?vue&type=template&id=5055a12a&scoped=true&"
import script from "./ResourceTypesListTable.vue?vue&type=script&lang=ts&"
export * from "./ResourceTypesListTable.vue?vue&type=script&lang=ts&"
import style0 from "./ResourceTypesListTable.vue?vue&type=style&index=0&id=5055a12a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5055a12a",
  null
  
)

export default component.exports